import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAllReview } from "../../Store/Action";
import "../../index.css";
import { Link } from "react-router-dom";
import { CircleCheck } from "lucide-react";
import { useThemeClass } from "@/Hooks/useThemeClass";
import clsx from "clsx";

const S3_URL = import.meta.env.VITE_S3_URL;

function ListDoneReview({ dataDoneReview }) {
  const themClass = useThemeClass()
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [dataDoneReview]);
  // console.log(dataDoneReview)
  return (
    <div className="flex mt-5 PB-10">
      <div className="w-full gap-6">
        {dataDoneReview?.length > 0 ? (
          dataDoneReview.map((el, index) => {
            const rewardText = el.reward
              .replace(/<[^>]*>?/g, "")
              .replace(/&nbsp;/g, " ");

            return (
              <div
                key={index}
                className="flex gap-3 mt-2 overflow-hidden transition-shadow border-b pb-2"
              >
                <div className="w-full flex">
                  <div className="w-10/12 flex">
                    <div className="w-24 h-24 flex-shrink-0 overflow-hidden rounded-lg">
                      <img
                        src={`${S3_URL}${el.thumbnail}`}
                        alt={el.title}
                        className="object-cover w-full h-full"
                      />
                    </div>

                    <div className="pl-2 max-w-[calc(100%-7rem)] flex flex-col justify-between">
                      <div>
                        <h3 className="font-bold text-[13px] text-gray-800 line-clamp-1">
                        {el.title ? el.title : "제목 없음"}
                        </h3>
                        <div className="flex text-[9px] ">
                             <p className="text-[11px] pt-1 text-[#999999] line-clamp-2 w-full">
                        {rewardText ? rewardText : "설명 없음"}


                        </p>
                        </div>
                      </div>
                      <div className="text-[8px] mt-2">
            
                      </div>
                    </div>
                  </div>

                  <div className="w-2/12 flex items-end justify-end">
                    <button
                      type="button"
                      disabled
                      className={clsx(themClass.bg('text'), `flex items-center gap-1 rounded-full text-[8px] shadow-sm px-2 border transition-colors text-white font-medium`)}
                    >
                      <CircleCheck width={12} />
                      리뷰완료
                    </button>
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <div className="text-[12px] text-center text-[#999999] items-center justify-center py-10">
            <p className="">신청한 캠페인이 없습니다.</p>
            <p className="mt-1">다양한 캠페인에 신청해보세요:)</p>
            <div>
              <Link to={"/"}>
                <button className="border text-[12px] bg-[#E8EAF9] mt-3 text-[#0F1E6C] rounded-full px-3 py-2">
                  <p>캠페인 신청하러가기</p>
                </button>
              </Link>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default ListDoneReview;
